import { Box, Typography } from "@mui/material";

const DuomenuNera = ({ pavadinimas, pranesimas = null }) => {
  return (
    <Box
      width="100%"
      height="100%"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box>
        {pavadinimas !== null && (
          <Typography>
            Negalima paskaičiuoti {<b>"{pavadinimas}"</b>} grafiko, nes trūksta arba nėra duomenų.
          </Typography>
        )}
        {pranesimas && (
          <>
            <Typography>{pranesimas}</Typography>
          </>
        )}
      </Box>
    </Box>
  );
};

export default DuomenuNera;
